import {
  createMemoryHistory,
  createRouter,
  createWebHistory,
} from 'vue-router';
import { gotoLogin, isLogin } from '@/utils/auth';
import { routes } from './routes';

/** 共享判定：仅判断，不产生副作用，两端共用 */
export function needAuth(to: { matched: { meta: Record<string, any> }[] }) {
  return to.matched.some(record => record.meta.requiresAuth);
}

export function createAppRouter() {
  const router = createRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes,
  });

  if (!import.meta.env.SSR) {
    router.beforeEach((to) => {
      if (needAuth(to) && !isLogin()) {
        gotoLogin(to.fullPath);

        return false;
      }

      return true;
    });

    import('./client-progress').then(m => m.installProgress(router));
  }

  return router;
}
